import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { useParams, useLocation } from "react-router-dom";

import { push } from "connected-react-router";

import { Breadcrumb, Menu } from "antd";
import {
  AlertOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FundProjectionScreenOutlined,
  PlaySquareOutlined,
  ProfileOutlined,
  RobotOutlined,
  BarChartOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";

function RobotNavigation(props) {
  const { robotName } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const robots = useSelector((state) => state.robot.robots);

  if (!robots) {
    return null;
  }

  const currentPath = location.pathname.split("/").slice(-1)[0];

  const { isCustomer } = props;

  const robot = robots.find((item) => item.name === robotName);

  if (!robot) {
    return null;
  }

  return (
    <Breadcrumb style={{ paddingBottom: 30 }}>
      <Breadcrumb.Item
        onClick={() => {
          dispatch(push("/"));
        }}
      >
        Overview
      </Breadcrumb.Item>
      <Breadcrumb.Item
        overlay={
          <Menu>
            {robots.map((item, index) => (
              <Menu.Item
                key={index}
                icon={<RobotOutlined />}
                onClick={() => {
                  dispatch(push(`/${item.name}/${currentPath}`));
                }}
              >
                {item.name}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        {robotName}
      </Breadcrumb.Item>

      <Breadcrumb.Item
        overlay={
          <Menu>
            {isCustomer && (
              <>
                <Menu.Item
                  key={`/${robotName}/health`}
                  icon={<AlertOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/health`));
                  }}
                >
                  Health
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/analytics`}
                  icon={<BarChartOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/analytics`));
                  }}
                >
                  Analytics
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/weld_test_results`}
                  icon={<SnippetsOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/weld_test_results`));
                  }}
                >
                  Weld Test Results
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/videos`}
                  icon={<FileSearchOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/search#videos`));
                  }}
                >
                  Videos
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/reports`}
                  icon={<FileSearchOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/search#reports`));
                  }}
                >
                  Daily Report
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/novdata_logs`}
                  icon={<FileSearchOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/search#novdata_logs`));
                  }}
                >
                  NovData Logs
                </Menu.Item>
              </>
            )}

            {!isCustomer && (
              <>
                <Menu.Item
                  key={`/${robotName}/summary`}
                  icon={<ProfileOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/summary`));
                  }}
                >
                  Summary
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/search`}
                  icon={<FileSearchOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/search`));
                  }}
                >
                  Search Files
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/weld_test_results`}
                  icon={<SnippetsOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/weld_test_results`));
                  }}
                >
                  Weld Test Results
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/videos`}
                  icon={<PlaySquareOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/videos`));
                  }}
                >
                  Video
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/reports`}
                  icon={<FilePdfOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/reports`));
                  }}
                >
                  Daily Report
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/novdata_logs`}
                  icon={<FileExcelOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/novdata_logs`));
                  }}
                >
                  NovData Log
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/noveye_logs`}
                  icon={<FileTextOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/noveye_logs`));
                  }}
                >
                  NovEye Log
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/health`}
                  icon={<AlertOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/health`));
                  }}
                >
                  Health
                </Menu.Item>
                <Menu.Item
                  key={`/${robotName}/statistics`}
                  icon={<FundProjectionScreenOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    dispatch(push(`/${robotName}/statistics`));
                  }}
                >
                  Stats
                </Menu.Item>
              </>
            )}
          </Menu>
        }
      >
        <span style={{ textTransform: "capitalize" }}>
          {/* {location.pathname.split("/").slice(-1)[0]} */}
          {location.hash
            ? location.hash.replace("#", "").replace(/_/g, " ")
            : location.pathname.split("/").slice(-1)[0].replace(/_/g, " ")}
        </span>
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default RobotNavigation;
